/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Detail_Label_DiscountInputs */

const vi_product_lot_detail_label_discount = /** @type {(inputs: Product_Lot_Detail_Label_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CK lô (%)`)
};

/**

* @param {Product_Lot_Detail_Label_DiscountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_detail_label_discount = /** @type {((inputs?: Product_Lot_Detail_Label_DiscountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Detail_Label_DiscountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_detail_label_discount(inputs)
});